<template>
  <div class="videoLearn">
    <div style="height:900px" v-if="iscomment==false"></div>
    <vsmallheader v-if="iscomment==true"></vsmallheader>
    <div class="header" v-if="iscomment==true" style="margin-top:20px">
      <div class="headerbox">
        <div style="position: relative;">
          <div style="width:100%;height:100%" class="videoPot" v-if="dataForm.documentType==2">
            <video-player
              v-if="dataForm.documentType==2"
              :class="['vjs-custom-skin']"
              style="object-fit: cover"
              ref="videoPlayer"
              id="videoPlayerId"
              :fluid="true"
              :options="playerOptions"
              :playsinline="false"
              :fullSreen="true"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @timeupdate="onPlayerTimeupdate($event)"
            ></video-player>

            <!-- <div class="next-box" v-show="visShow">
              <div class="replayclas">当前视频已看完！</div>
            </div>-->

            <div class="next-box" v-show="recordshow">
              <div class="nextboxcenter">
                <div v-if="!videoarr" class="nextboxcenter">上次播放到{{ playtiembl}}，</div>
                <div v-if="videoarr" class="nextboxcenter">当前已看完！</div>
                <div class="nextboxcenterbtn">
                  <el-button
                    type="success"
                    round
                    @click="toContinue"
                    style="background:#fff;border:1px solid #fff;color:#333"
                    v-if="!videoarr"
                  >继续播放</el-button>
                  <el-button
                    type="primary"
                    round
                    @click="restart"
                    style="background:#fff;border:1px solid #fff;color:#333"
                  >重新开始</el-button>
                  <el-button
                    type="success"
                    round
                    v-if="videoarr"
                    style="background:#fff;border:1px solid #fff;color:#333"
                    @click="nextShow"
                  >下一个</el-button>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else-if="dataForm.documentType==1"
            class="next-boxifbox"
            style="position: relative;"
          >
            <iframe
              :src="pdfUrl"
              frameborder="0"
              width="1200"
              height="648;"
              ref="iframes"
              @scroll.passive="scroll($event)"
              style="height:648px"
            ></iframe>
            <div class="next-boxifarmm" v-show="pdfshow">
              <!-- <span>当前已看完！</span> -->
              <el-button
                type="success"
                style="background:#fff;border:1px solid #fff;color:#333"
                round
                @click="jigk"
              >继续观看</el-button>
              <el-button
                type="success"
                style="background:#fff;border:1px solid #fff;color:#333"
                round
                @click="nextShow"
              >下一个</el-button>
            </div>
          </div>

          <!-- </div> -->

          <div class="ras-time" v-if="hideDiaolog && dataForm.documentType==1">{{learnTimes}}</div>

          <div
            v-else-if="dataForm.documentType==4"
            style="text-align: center;padding:30px; min-height: 400px"
            class="audioclass"
          >
            <!-- <div style="font-size:24px">音频名称:{{dataForm.name}}</div> -->
            <div>
              <audio controls style="margin-top:10px;">
                <!-- <source src="horse.ogg" type="audio/ogg"> -->
                <source :src="dataForm.filePath" type="audio/mpeg" />
              </audio>
            </div>
          </div>

          <div
            v-else-if="dataForm.documentType==3"
            style="text-align: center; min-height: 400px"
            class="audioclass"
          >
            <!-- <div style="font-size:24px">图片名称:{{dataForm.name}}</div> -->
            <div style="width: 100%;text-align: center;">
              <img :src="dataForm.filePath" alt style=" max-width: 100%;max-height: 100%;" />
            </div>
          </div>
        </div>
        <div class="icon">
          <!-- <div class="txIcon">提醒：视频要完全播放完后，才可以产生积分，培训班的学习任务才会显示已学习.</div> -->
          <div class="txIcon">当前观看人数：{{dataForm.visitNum}}</div>
          <div class="iconright">
            <div @click="give()" class="videimg" style="cursor: pointer;">
              <img src="@/assets/resource/taklles.png" alt v-if="giveflag==false" />
              <img src="@/assets/resource/takllesActive.png" alt v-else />
              {{dataForm.assistCount}}
            </div>
            <div @click="collect()" class="videimg" style="cursor: pointer;">
              <img src="@/assets/resource/colles.png" alt v-if="collectflag==false" />
              <img src="@/assets/resource/collesActive.png" alt v-else />
              {{dataForm.collectionCount}}
            </div>
            <div
              @click="downloadres(dataForm)"
              class="videimg"
              style="cursor: pointer;"
              v-if="dataForm.isDown"
            >
              <img src="@/assets/videoimg/download.svg" alt />
              下载
            </div>
            <div
              @click="downloadresNone(dataForm)"
              class="videimg"
              style="cursor: not-allowed;"
              v-else
            >
              <img src="@/assets/videoimg/download.svg" alt />
              下载
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="matter" v-if="iscomment==true">
      <div class="matterbox" v-if="iscomment==true">
        <div class="heheh">
          <v-video-review v-if="isShowcommt" :dataForm="dataForm" :ishiden="1"></v-video-review>
        </div>

        <div class="popular">
          <div class="popularbox">
            <div class="populartop">
              <div class="populartoptitle">全部学习</div>
              <div class="populartopright">
                <div class="eavBtn" @click="elvaAll">查看全部</div>
                <!-- <div class="eavBtntw">未学完</div> -->
                <div class="progresstotal">
                  <ins
                    data-progress="0"
                    :style="{ width: totaNum + '%' }"
                    style="display: inline-block"
                  ></ins>
                </div>
                <div class="press">{{completed.length}}/{{popular.length}}</div>
              </div>
            </div>
            <div class="popularmetter" v-if="popular.length!==0">
              <div class="populardata" v-for="(item,index) in popular" :key="index">
                <div class="populardatatop">
                  <div class="types" v-if="item.documentType==1">文档</div>
                  <div class="types" v-else-if="item.documentType==3">图片</div>
                  <div class="types" v-else-if="item.documentType==4">音频</div>
                  <div class="types" v-else>视频</div>

                  <div class="typestxt">{{item.name}}</div>
                </div>
                <div class="progressbox">
                  <div class="progress">
                    <ins
                      data-progress="0"
                      style="display: inline-block;"
                      :style="{ width: item.percentage + '%' }"
                    ></ins>
                  </div>

                  <div class="press">{{item.percentage?item.percentage:0}}%</div>
                  <div class="typesbtn" v-if="item.percentage == 100 || index == 0" @click="playVideoBtn(item)">立即学习</div>
                  <div v-else class="typesbtn noPlanBtn">立即学习</div>
                </div>
              </div>
            </div>
            <nodata v-else></nodata>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showdiaLog"
      :close-on-click-modal="false"
      center
      :show-close="false"
      width="400px"
    >
      <div class="learn-time">学习时间必须达到：{{learnTimes*60}}秒</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitTime">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="isLearnDialog" center title="提示" show-close width="400px">
      <div class="learn-time">你已经学习完，是否前往考试？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isLearnDialog=false">取 消</el-button>
        <el-button type="primary" @click="goExamPaper">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="isLearnDialogxt" center title="提示" show-close width="400px">
      <div class="learn-time">你已经学习完成。</div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="isLearnDialogxt=false">取 消</el-button>
        <el-button type="primary" @click="goExamPaper">确 定</el-button>
      </span>-->
    </el-dialog>

    <!-- 准入学习列表 -->
    <el-dialog
      v-if="dialogFormisLearnVisible"
      :visible.sync="dialogFormisLearnVisible"
      center
      title="准入测试学习内容"
      show-close
      width="55%"
    >
      <div style="display:flex;padding:10px 0 20px 0">
        <el-input
          v-model="listQuerysLearn.name"
          style="width: 200px;height: 35px;"
          placeholder="请输入资源名称"
          size="mini"
        ></el-input>
        <el-button
          size="mini"
          style="height: 35px;margin-left:10px"
          type="primary"
          icon="el-icon-search"
          @click="GetCourseAll"
        >搜索</el-button>
      </div>

      <div>
        <el-table ref="JLTable" :data="CourseAllList" border style="width:100%" height="450">
          <el-table-column min-width="100px" :label="'名称'" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="title-text-up" v-if="scope.row.percentage == 100" @click="playVideoBtn(scope.row,1)">{{ scope.row.name }}</span>
              <span v-else>{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column
            min-width="100px"
            :label="'授课内容'"
            :show-overflow-tooltip="true"
            align="center"
            prop="contents"
          ></el-table-column>

          <el-table-column width="110px" :label="'类型'" align="center" prop="jzName"></el-table-column>

          <el-table-column
            width="100px"
            :label="'状态'"
            prop="unitname"
            align="center"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column width="210px" min-height="140px" :label="'学习进度'" align="center">
            <template slot-scope="scope">
              <div class="progressBoxss">
                <div class="progressxxx">
                  <ins
                    data-progress="0"
                    style="display: inline-block;"
                    :style="{ width: scope.row.percentage + '%' }"
                  ></ins>
                </div>
                <div style="padding-left:10px">{{scope.row.percentage?scope.row.percentage:0}}%</div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuerysLearn.page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="listQuerysLearn.limit"
            layout="total,sizes, prev, pager, next"
            :total="total"
            v-if="total>0"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getInfo } from '@/utils/auth';
import vsmallheader from '@/views/smallHeader/index';
import * as resourceInfo from '@/api/resources/index.js';
import * as givecollect from '@/api/public.js';
import * as ApiPerson from '@/api/personcenter/index';
import vVideoReview from '../../resources/videoLearn/components/videoReview/index.vue';
import Pagination from '@/components/Pagination';
import Vue from 'vue';
import VideoPlayer from 'vue-video-player';
window.videojs = VideoPlayer.videojs;
require('video.js/dist/lang/zh-CN.js');
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import 'videojs-flash'; //引入才能播放rtmp视屏
import 'videojs-contrib-hls'; //引入才能播放m3u8文件
Vue.use(VideoPlayer);
export default {
  components: {
    vVideoReview,
    vsmallheader,
    Pagination,
  },
  data() {
    return {
      isLearnLlist: [],
      dialogFormisLearnVisible: false,
      isLearnDialogxt: false,
      playtiembl: '',
      playerOptions: {
        objectFit: 'contain',
        height: '540px',
        size: '100%',
        autoplay: false,
        muted: false,
        language: 'en',
        webkitPlaysinline: 'true',
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        sources: [
          {
            src: '',
          },
        ],
        presentTiem: '',
        videoStepId: '',
      },
      trainId: this.$route.query.trainid,
      resourceId: null,
      iscomment: false,
      recordshow: false,
      learnTime: 0,
      playTime: 0,
      record: '',
      isOver: null,
      countdown: 5,
      timer: null,
      visShow: false,
      // resourceId: this.$route.query.id,
      dataForm: {},
      giveflag: '',
      collectflag: '',
      gklog: 0,
      pdfUrl: '',
      popular: [],
      videoComplete: false,
      isShowcommt: false,
      showdiaLog: false,
      learnTimes: 60,
      hideDiaolog: false,
      intervalTime: null,
      isLearnDialog: false,
      learnstaus: this.$route.query.learnstaus,
      typejuge: this.$route.query.typejuge,
      listQuerysLearn: {
        page: 1,
        limit: 10,
        trainId: this.$route.query.trainid,
        userId: this.$store.state.User.ids,
        name: '',
      },
      total: 0,
      CourseAllList: [],
      videoarr: false,
      videoarrisShow: false,
      pdfshow: false,
      unfinished: [],
      completed: [],
      totaNum: 0,
      ipUrl: "",
      isBar: false,
      isBarInit: 0,
    };
  },

  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  created() {
    this.learnstaus = this.$route.query.learnstaus;
    this.getlistvideolist();
  },
  mounted() {
    // debounce 是一个防抖工具类函数 需要自己定义
  },

  methods: {
    jigk() {
      this.pdfshow = false;
    },
    // 点击下一个视频
    nextShow() {
      let list = this.popular;
      let resId = '';
      let learnTimes = 0;
      // if (this.videoarrisShow) {
      resId = this.popular[0].objId;
      learnTimes = this.popular[0].cnt;
      // } else {
      //   for (let i = 0; i < list.length; i++) {
      //     if (list[i].objId == this.resourceId) {
      //       resId = list[i + 1].objId;
      //       learnTimes = list[i + 1].cnt;
      //     }
      //   }
      // }

      this.resourceId = resId;
      this.learnTimes = learnTimes;
      if (resId) {
        this.DocumentRecordList(); //查询上次播放记录
      }
    },
    // 获取总进度
    getinslist() {
      this.unfinished = [];
      this.completed = [];
      this.totaNum = 0;
      for (let i = 0; i < this.popular.length; i++) {
        if (this.popular[i].percentage == 100) {
          this.completed.push(this.popular[i]);
        } else {
          this.unfinished.push(this.popular[i]);
        }
      }

      let sum = this.popular.length;
      let sumcompleted = this.completed.length;

      this.totaNum = (sumcompleted / sum).toFixed(2) * 100;
    },

    // 点击弹出播放视频
    progressManage(row) {},
    // 查看全部
    elvaAll() {
      this.GetCourseAll();
    },

    handleSizeChange(val) {
      this.listQuerysLearn.limit = val;
      this.GetCourseAll();
    },
    handleCurrentChange(val) {
      this.listQuerysLearn.page = val;
      this.GetCourseAll();
    },

    //前往考试
    goExamPaper() {
      localStorage.setItem('trainId', this.trainId);
      this.$router.replace({
        path: '/simulationExamPerson',
        query: {
          trainId: this.trainId,
          trainName: this.$route.query.trainName,
          learnscore: this.$route.query.learnscore,
        },
      });
    },
    //是否学完
    isLearn() {
      let para = {
        userId: this.$store.state.User.ids,
        trainId: this.trainId,
        typejuge: this.typejuge,
      };
      ApiPerson.isLearn(para).then((res) => {
        if (res.result && this.learnstaus == 0) {
          if (this.typejuge == 3) {
            this.isLearnDialogxt = true;
          } else {
            this.isLearnDialog = true;
          }
        }
      });
    },
    // 获取弹窗资源数据
    GetCourseAll() {
      this.CourseAllList = [];
      resourceInfo.GetCourseAll(this.listQuerysLearn).then((res) => {
        this.CourseAllList = res.data;
        this.total = res.count;
        this.dialogFormisLearnVisible = true;
        // console.log(res)
      });
    },
    //添加浏览
    getRead(val) {
      let para = {
        userId: this.$store.state.User.ids,
        id: this.resourceId,
      };
      ApiPerson.getRead(para).then((res) => {
        this.beforegetList(val);
      });
    },
    //启动定时器
    submitTime() {
      this.showdiaLog = false;
      this.learnTimes = this.learnTimes * 60;
      if (this.learnTimes != 0) {
        this.hideDiaolog = true;
        this.intervalTime = setInterval(() => {
          if (this.learnTimes != 0) {
            this.learnTimes -= 1;
          } else {
            this.hideDiaolog = false;
            this.pdfshow = true;
            this.addCourserecord(true);
            clearInterval(this.intervalTime);
          }
        }, 1000);
      } else {
        this.hideDiaolog = false;
        this.addCourserecord(true);
      }
    },
    // 点击开始播放
    playVideoBtn(item, index) {
      if (item.percentage != 100) {
        this.isOver = false;
      }
      localStorage.removeItem('videoTiem');
      this.isShowcommt = false;
      this.resourceId = item.objId;
      this.learnTimes = item.cnt;
      if (index == 1) {
        this.videoarrisShow = true;
        this.dialogFormisLearnVisible = false;
      }

      this.DocumentRecordList(); //查询上次播放记录
      clearInterval(this.intervalTime);
    },
    // 查询当前播放的资源列表
    getlistvideolist(val) {
      let para = {
        trainId: this.trainId,
        userId: this.$store.state.User.ids,
      };
      ApiPerson.getCourseList(para).then((res) => {
        this.popular = res.data;
        if(val != 1) {
          if(res.data.length != 0){
            if (res.data[0].percentage == 100) {
              this.learnTimes = res.data[0].cnt;
              this.resourceId = res.data[0].objId;
              localStorage.removeItem('videoTiem');
              this.DocumentRecordList();
            } else {
              this.learnTimes = res.data[0].cnt;
              this.resourceId = res.data[0].objId;
              localStorage.removeItem('videoTiem');
              this.DocumentRecordList(); //查询上次播放记录
            }

            // 判断是否登录
            if (getInfo('tokens')) {
              this.whethergive();
              this.whethercollect();
            }
          }
        }
      });
    },

    retrun() {
      // 如果是从个人中心入的，就需要返回个人中心，如果过是首页进入的就直接调回首页
      if (localStorage.getItem('fullPath') == '/personCenter') {
        this.$router.go(-1);
      } else if (localStorage.getItem('fullPath') == '/home') {
        this.$router.go(-1);
      } else {
        this.$router.push('/sourceslist');
      }
    },
    // 查询播放记录 DocumentRecordGet
    DocumentRecordList() {
      let data = {
        documentId: this.resourceId,
        userId: Number(
          this.$store.state.User.ids ? this.$store.state.User.ids : 0
        ),
        trainId: this.trainId,
      };
      // console.log(data);
      resourceInfo.DocumentRecordGet(data).then((res) => {
        console.log(res);
        
        if (res.result.length != 0) {
          //有记录
          this.isOver = res.result[0].isOver;
          this.playTime = res.result[0].playTime;
          this.getsecondMinute(this.playTime);

          this.getRead();
        } else {
          this.isOver = false;
          this.playTime = 0;
          this.getRead(0);
        }
      });
    },
    // 秒化成分钟
    getsecondMinute(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? '0' + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? '0' + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? '0' + Math.floor(result % 60)
          : Math.floor(result % 60);
      if (h == 0 && m != 0) {
        this.playtiembl = m + '分' + s + '秒';
      } else if (m == 0 && h == 0) {
        this.playtiembl = s + '秒';
      } else if (h != 0) {
        this.playtiembl = h + '时' + m + '分' + s + '秒';
      }
    },
    // 继续播放
    toContinue() {
      this.recordshow = false;
      this.$refs.videoPlayer.player.currentTime(this.playTime); //插入当前卡点的时间
      this.$refs.videoPlayer.player.play();
    },
    // 重新开始
    restart() {
      this.learnTime = 0;
      this.recordshow = false;
      this.$refs.videoPlayer.options.autoplay = true;
      this.$refs.videoPlayer.player.play();
    },
    //获取数据前
    beforegetList(val){
      let vdata = val;
      resourceInfo.getDocumentIp().then(res=>{
        if(res.code == 200){
          this.ipUrl = res.result;
          this.getList(vdata);
        }else{
          this.$message({
                message: res.message,
                type: 'error',
              });
        }
      })
    },
    getList(val) {
      let ipUrl = this.ipUrl;
      resourceInfo.DocumentGetDetail({ id: this.resourceId }).then((res) => {
        this.dataForm = res.result[0];
        this.iscomment = true;
        this.isShowcommt = true;
        this.whethergive();
        this.whethercollect();
        this.getinslist();
        if (this.dataForm.documentType == 2) {
          if (this.isOver == false && this.playTime > 5) {
            //有记录

            this.playerOptions.sources[0].src = ipUrl + this.dataForm.filePath;
            // console.log(this.dataForm.filePath);
            this.recordshow = true;
            this.videoarr = false;
          } else {
            this.$nextTick(() => {
              this.playerOptions.sources[0].src = ipUrl + this.dataForm.filePath;
              console.log(this.dataForm.filePath);
              this.$refs['videoPlayer'].options.autoplay = true;
              this.$refs['videoPlayer'].player.play();
              this.recordshow = false;
            });
          }
        }
        this.pdfshow = false;
        if (this.dataForm.documentType == 1) {
          this.pdfUrl =
            '/pdf/web/viewer.html?file=' +
            encodeURIComponent(ipUrl +this.dataForm.filePath);
          this.showdiaLog = true;
        }
        if (this.dataForm.documentType > 2) {
          this.addCourserecord(true);
        }
      });
    },
    // 添加播放记录
    addCourserecord(isOver) {
      let data = {
        userId: Number(
          this.$store.state.User.ids ? this.$store.state.User.ids : 0
        ),
        trainId: this.trainId ? this.trainId : 0,
        documentId: Number(this.resourceId), //资源id
        fileType: this.dataForm.documentType, //类型
        isOver: isOver,
      };

      if (this.dataForm.documentType == 2) {
        data.playTime = Math.floor(this.gklog); //播放时长
        if (this.learnTime > 4) {
          let learnTime = Math.floor(this.learnTime) / 4;
          //记录学习时长
          data.learnTime = Math.floor(learnTime) - 2;
        }
      }

      resourceInfo.DocumentRecordst(data).then((res) => {
        this.isLearn();
        this.getlistvideolist(1);
      });
    },
    // 视频开始
    onPlayerPlay(player) {
      this.$refs.videoPlayer.$el.firstChild.getElementsByClassName('vjs-control-bar')[0].getElementsByClassName('vjs-progress-control')[0].style.pointerEvents = 'none';
      this.isBar = true;
    },
    // 视频暂停
    onPlayerPause(player) {},
    // 视频结束事件
    onPlayerEnded(player) {
      this.videoComplete = true;
      if (this.isOver != true && this.gklog > 5) {
        //有记录的情况下才插入记录
        this.addCourserecord(true); //插入视频记录
      }

      this.videoarr = true;
      this.recordshow = true;
    },
    getLearnOver() {
      let para = {
        userId: Number(
          this.$store.state.User.ids ? this.$store.state.User.ids : 0
        ),
        trainId: this.trainId ? this.trainId : 0,
      };
      ApiPerson.getLearnOver(para).then((res) => {});
    },
    // 视频事件
    //监听播放器时间
    onPlayerTimeupdate(player) {
      // this.gklog = player.currentTime();
      // this.learnTime++;
      this.gklog = player.currentTime();
      this.learnTime++;
      let olbTiem = localStorage.getItem('videoTiem');
      if (this.learnTimes > 0) {
        if (
          Number(this.gklog) - Number(olbTiem ? olbTiem : 0) >
          this.learnTimes
        ) {
          //this.$refs.videoPlayer.player.currentTime(olbTiem); //插入当前卡点的时间
          //this.$refs.videoPlayer.player.play();
          this.$refs.videoPlayer.$el.firstChild.getElementsByClassName('vjs-control-bar')[0].getElementsByClassName('vjs-progress-control')[0].style.pointerEvents = 'none';
          this.isBar = true;
        }
        if(this.isBarInit == 0){
          this.isBarInit = 1;
          this.$refs.videoPlayer.$el.firstChild.getElementsByClassName('vjs-control-bar')[0].getElementsByClassName('vjs-progress-control')[0].style.pointerEvents = 'none';
          this.isBar = true;
        }
      }else{
        if(this.isBar){
          this.$refs.videoPlayer.$el.firstChild.getElementsByClassName('vjs-control-bar')[0].getElementsByClassName('vjs-progress-control')[0].style.pointerEvents = 'auto';
          this.isBar = false;
        }
      }
      localStorage.setItem('videoTiem', this.gklog);
    },
    // 判断是否点赞
    whethergive() {
      let para = {
        objId: this.resourceId,
        objType: 1,
        userId: this.$store.state.User.ids,
      };
      givecollect.AssistIsAssist(para).then((res) => {
        this.giveflag = res.result;
      });
    },
    //判断是否收藏
    whethercollect() {
      let para = {
        objId: this.resourceId,
        objType: 1,
        userId: this.$store.state.User.ids,
      };
      givecollect.CollectionIsColl(para).then((res) => {
        this.collectflag = res.result;
      });
    },
    give() {
      if (getInfo('tokens')) {
        if (this.giveflag == false) {
          //添加点赞
          let para = {
            objType: 1,
            objId: this.resourceId,
            createId: this.$store.state.User.ids,
          };
          givecollect.AssistAdd(para).then((res) => {
            this.$message({
              message: '点赞成功',
              type: 'success',
            });
            this.whethergive();
            this.dataForm.assistCount = this.dataForm.assistCount + 1;
          });
        } else {
          //取消点赞
          let para = {
            objType: 1,
            objId: this.resourceId,
            userId: this.$store.state.User.ids,
          };
          givecollect.AssistDelete(para).then((res) => {
            this.whethergive();
            this.$message({
              message: '取消点赞成功',
              type: 'success',
            });
            this.dataForm.assistCount = this.dataForm.assistCount - 1;
          });
        }
      } else {
        window.clikLogin();
      }
    },
    //播放下一个倒计时
    sendCode() {
      this.loading(); //启动定时器
      this.timer = setInterval(() => {
        //创建定时器
        if (this.countdown === 1) {
          this.clearTimer(); //关闭定时器

          this.visShow = false;
        } else {
          this.loading();
        }
      }, 1000);
    },
    loading() {
      //启动定时器
      this.countdown--; //定时器减1
    },
    clearTimer() {
      //清除定时器
      clearInterval(this.timer);
      this.timer = null;
    },
    collect() {
      if (getInfo('tokens')) {
        if (this.collectflag == false) {
          //添加收藏
          let para = {
            objType: 1,
            objId: this.resourceId,
            createId: this.$store.state.User.ids,
          };
          givecollect.CollectionAdd(para).then((res) => {
            this.$message({
              message: '收藏成功',
              type: 'success',
            });
            this.whethercollect();
            this.dataForm.collectionCount = this.dataForm.collectionCount + 1;
          });
        } else {
          //取消收藏
          let para = {
            objType: 1,
            objId: this.resourceId,
            userId: this.$store.state.User.ids,
          };
          givecollect.CollectionDele(para).then((res) => {
            this.whethercollect();
            this.$message({
              message: '取消收藏成功',
              type: 'success',
            });
            this.dataForm.collectionCount = this.dataForm.collectionCount - 1;
          });
        }
      } else {
        window.clikLogin();
      }
    },
    downloadres(dataForm) {
      dataForm.documentpath = dataForm.documentPath ? dataForm.documentPath : dataForm.documentpath;
      let a = document.createElement('a');
      a.setAttribute('download', dataForm.name);
      a.setAttribute('target', '_blank');
      a.setAttribute('href', dataForm.documentpath);
      a.click();
    },
    downloadresNone() {},
  },

  // 页面销毁的时候插入记录
  beforeDestroy() {
    if (this.dataForm.documentType == 2) {
      if (this.isOver != true && this.gklog > 5) {
        this.addCourserecord(false); //插入视频记录
      }
      // let player = videojs('videoPlayer');
      // player.dispose();
      this.$refs.videoPlayer.dispose();
    }
    clearInterval(this.intervalTime);
    localStorage.removeItem('videoTiem');
    window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e));
  },
};
</script>
<style scoped>
/* 视频pdf区域 */
.header {
  width: 100%;
}
.headerbox {
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #f2f2f2;
}

.headerbox > div:nth-child(2) {
  height: 64px;
}
.icon {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f2f2f2;
}
.iconleft {
  display: flex;
  margin-left: 100px;
}
.iconleft > div:nth-child(1) {
  margin-top: 15px;
  width: 30px;
  height: 30px;
  background-size: contain;
  background-image: url('../../../assets/resource/u231.svg');
  background-repeat: no-repeat;
}
.iconleft > div:nth-child(2) {
  margin-top: 22px;
  width: 30px;
  height: 30px;
  margin-left: 12px;
}
.iconleft > div:nth-child(3) {
  margin-top: 19px;
  margin-left: 30px;
  width: 25px;
  height: 25px;
  background-size: contain;
  background-image: url('../../../assets/resource/u234.svg');
  background-repeat: no-repeat;
}
.iconleft > div:nth-child(4) {
  margin-top: 22px;
  width: 30px;
  height: 30px;
  margin-left: 12px;
}
.iconright {
  display: flex;
  align-items: center;
}
.iconright > div {
  margin-right: 40px;
}
.iconright > div > img {
  margin-right: 5px;
  width: 25px;
  height: 25px;
  vertical-align: middle;
}
.videimg {
  display: flex;
  align-items: center;
}
.matterbox {
  width: 1200px;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  /* justify-content: space-around; */
  justify-content: space-between;
}
.matterbox > div:nth-child(1) {
  flex: 1;
  min-height: 400px;
  margin-right: 30px;
}
.matterbox > div:nth-child(2) {
  width: 350px;
  /* border: 1px solid #f2f2f2; */
}
.videoPot {
  position: relative;
}
.next-box {
  position: absolute;
  z-index: 999;
  border-radius: 20px;
  width: 100%;
  height: 540px;
  color: #fff;
  background-color: rgb(8, 8, 8);
  text-align: center;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  top: 0;
  left: 0;
}
.nextboxcenter {
  padding: 0 0 20px 0;
  font-size: 25px;
  font-weight: bold;
}
.nextboxcenterbtn {
  display: flex;
}
.next-boxifbox {
  position: relative;
  width: 1200px;
  height: 648px;
}
.next-boxifarmm {
  position: absolute;
  z-index: 999;
  border-radius: 20px;
  width: 100%;
  height: 648px;
  color: #fff;
  background-color: rgb(8, 8, 8);
  text-align: center;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
}
.replayclas {
  color: #8cb822;
  font-size: 18px;
}
.txIcon {
  line-height: 64px;
  color: #6d6b6b;
  font-size: 14px;
  padding-left: 20px;
}
.audioclass {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #aaa;
}

/* 右侧 */
.popular {
  width: 300px;
}
/* 标题样式 */
.populartop {
  height: 50px;
  color: #555;
  border-bottom: solid 1px #f2f2f2;
  display: flex;
  align-items: center;
}
.populartoptitle {
  line-height: 50px;
  font-size: 18px;
  font-weight: bold;
  padding-left: 8px;
}
.populartopright {
  flex: 1;
  padding: 0 5px;
  display: flex;
  align-items: center;
}
.popularmetter {
  margin-top: 8px;
  padding: 0 5px;
  overflow: hidden;
  overflow-y: auto;
  height: 700px;
}
/* 单个数据 */
.populardata {
  padding-top: 10px;
}
.populardatatop {
  display: flex;
  align-items: center;
}
.types {
  height: 20px;
  width: 50px;
  text-align: center;
  line-height: 20px;
  border: 1px solid #15b6f1;
  border-radius: 5px;
  color: #15b6f1;
  font-size: 13px;
}
.typestxt {
  flex: 1;
  padding-left: 10px;
  font-size: 15px;
  font-weight: bold;
}

.press {
  color: #15b6f1;
  flex: 1;
  padding-left: 5px;
}
.typesbtn {
  height: 25px;
  line-height: 25px;
  width: 77px;
  color: #fff;
  background-color: #3d9ffe;
  border-radius: 5px;
  text-align: center;
}
.noPlanBtn{
  color: #f2f2f2 !important;
  background-color: #aaa !important;
}
.noPlanBtn:hover{
  cursor: not-allowed !important;
}
.eavBtntw,
.eavBtn {
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  cursor: pointer;
}
.eavBtn {
  width: 68px;
  height: 26px;
  margin-right: 5px;
  border: 1px solid #15b6f1;
  color: #15b6f1;
}
.eavBtntw {
  width: 70px;
  height: 28px;
  background-color: #f59a23;
  color: #fff;
}
.typesbtn:hover {
  cursor: pointer;
}
/deep/.el-input--mini .el-input__inner {
  height: 35px !important;
  line-height: 35px !important;
}
</style>

<style lang="scss" scoped>
.progressbox {
  display: flex;
  align-items: center;
  margin: 15px 0 15px 0;
  .progress {
    width: 180px;
    height: 10px;
    background: rgba(28, 31, 33, 0.1);
    border-radius: 8px;
    position: relative;

    ins {
      position: absolute;
      top: 0;
      left: 0;
      height: 10px;
      content: '';
      width: 0%;
      transition: 2s width;
      background: linear-gradient(
        to right,
        rgb(150, 217, 248),
        rgba(135, 245, 162)
      );
      border-radius: 8px;
    }
  }
}

.resourceIRLeftTab {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  padding: 20px;
  width: 350px;
  .resourceIRLeftTabli {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    letter-spacing: 1px;
    width: 100px;
    height: 36px;
    line-height: 36px;
    border: 1px solid #1492ff;
    color: #1492ff;
    // box-shadow: -5px -4px 5px rgb(215 215 215 / 98%);
    border-radius: 5px;

    &:hover {
      cursor: pointer;
      background-color: #1492ff;
      color: #fff;
    }
  }
  .navLi:hover {
    border-bottom: solid 1px #1492ff;
  }
}

.progressBoxss {
  width: 180px;
  display: flex;
  align-items: center;
}
.progressxxx {
  width: 120px;
  height: 10px;
  background: rgba(28, 31, 33, 0.1);
  border-radius: 8px;
  position: relative;

  ins {
    position: absolute;
    top: 0;
    left: 0;
    height: 10px;
    content: '';
    width: 0%;
    transition: 2s width;
    background: linear-gradient(
      to right,
      rgb(150, 217, 248),
      rgba(135, 245, 162)
    );
    border-radius: 8px;
  }
}

.learn-time {
  text-align: center;
  font-weight: 700;
  font-size: 18px;
}
.ras-time {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: #999999;
  color: white;
  font-size: 18px;
  font-weight: 700;
  border-radius: 50%;
  position: absolute;
  top: 50px;
  left: 50%;
}
.resourceIRLeactive {
  cursor: pointer;
  background-color: #1492ff;
  color: #fff !important;
}
.title-text-up:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #1492ff;
}
.progresstotal {
  width: 120px;
  height: 10px;
  background: rgba(28, 31, 33, 0.1);
  border-radius: 8px;
  position: relative;
  ins {
    position: absolute;
    top: 0;
    left: 0;
    height: 10px;
    content: '';
    width: 0%;
    transition: 2s width;
    background: linear-gradient(
      to right,
      rgb(150, 217, 248),
      rgba(135, 245, 162)
    );
    border-radius: 8px;
  }
}
.vjs-progress-control{
  pointer-events: none !important;
}
</style>